// import React, { useState, useEffect, useCallback } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import api from '../../services/api';
// import toast from 'react-hot-toast';
// import { LoadingSpinner } from '../../components/UI';
// import zonesGeoJson from '../../data/zones.json';
// import wardsData from '../../data/wards.json';

// const API_BASE = (process.env.REACT_APP_API_URL || 'https://cmsapi3.vdavns.com/api').replace('/api', '');
// const steps = ['Select NOC', 'Documents Required', 'Your Details', 'Upload Documents', 'Submit'];

// // ── Point-in-polygon (ray casting) ───────────────────────────
// function pointInPolygon(lat, lng, polygon) {
//   let inside = false;
//   for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
//     const xi = polygon[i][0], yi = polygon[i][1];
//     const xj = polygon[j][0], yj = polygon[j][1];
//     const intersect = ((yi > lat) !== (yj > lat)) &&
//       (lng < (xj - xi) * (lat - yi) / (yj - yi) + xi);
//     if (intersect) inside = !inside;
//   }
//   return inside;
// }

// // ── Detect zone from lat/lng ──────────────────────────────────
// function detectZoneFromCoords(lat, lng) {
//   for (const feature of zonesGeoJson.features) {
//     const coords = feature.geometry.coordinates[0];
//     // GeoJSON is [lng, lat] — swap for our check
//     if (pointInPolygon(lng, lat, coords)) {
//       return feature.properties.zone_id;
//     }
//   }
//   return null;
// }

// export default function ApplyNOC() {
//   const [step, setStep]             = useState(0);
//   const [nocTypes, setNocTypes]     = useState([]);
//   const [selectedNoc, setSelectedNoc] = useState(null);
//   const [demands, setDemands]       = useState([]);
//   const [loadingDemands, setLoadingDemands] = useState(false);
//   const [submitting, setSubmitting] = useState(false);
//   const [errors, setErrors]         = useState({});
//   const [detectedZone, setDetectedZone] = useState(null);

//   const [form, setForm] = useState({
//     applicant_name: '', applicant_address: '', applicant_email: '',
//     applicant_mobile: '', latitude: '', longitude: '',
//     description: '', ward_id: '', zone_id: '',
//   });
//   const [docRows, setDocRows] = useState([{ name: '', file: null }]);

//   const navigate   = useNavigate();
//   const { role }   = useSelector(s => s.auth);

//   // Operator roles — no autofill
//   const isOperator = ['operator1', 'operator2'].includes(role);

//   // Sarai NOC — needs ward + zone
//   const isSaraiNoc = selectedNoc?.noc_code?.toUpperCase().includes('SARAI') ||
//                      selectedNoc?.noc_name?.toLowerCase().includes('sarai');

//   const wards = wardsData.wards || [];
//   const zones = wardsData.zones || [];

//   useEffect(() => {
//     api.get('/noc-types/public?active_only=1').then(r => setNocTypes(r.noc_types || []));

//     // Autofill for citizen only (not operator)
//     if (!isOperator) {
//       api.get('/auth/profile').then(r => {
//         if (r.user) {
//           setForm(p => ({
//             ...p,
//             applicant_name:    r.user.name    || '',
//             applicant_mobile:  r.user.mobile  || '',
//             applicant_email:   r.user.email   || '',
//             applicant_address: r.user.address || '',
//           }));
//         }
//       }).catch(() => {});
//     }
//   }, []);

//   // Detect zone when lat/lng changes (for Sarai NOC)
//   useEffect(() => {
//     if (isSaraiNoc && form.latitude && form.longitude) {
//       const zoneId = detectZoneFromCoords(
//         parseFloat(form.latitude),
//         parseFloat(form.longitude)
//       );
//       if (zoneId) {
//         setDetectedZone(zoneId);
//         setForm(p => ({ ...p, zone_id: String(zoneId) }));
//       }
//     }
//   }, [form.latitude, form.longitude, isSaraiNoc]);

//   const f = (k, v) => setForm(p => ({ ...p, [k]: v }));

//   const handleSelectNoc = async (noc) => {
//     setSelectedNoc(noc);
//     setLoadingDemands(true);
//     try {
//       const r = await api.get(`/noc-demands/${noc.id}`);
//       setDemands(r.demands || []);
//       if (r.demands?.length) {
//         setDocRows(r.demands.map(d => ({ name: d.document_name, file: null, mandatory: d.is_mandatory })));
//       } else {
//         setDocRows([{ name: '', file: null }]);
//       }
//     } finally { setLoadingDemands(false); }
//   };

//   const getLocation = () => {
//     navigator.geolocation.getCurrentPosition(
//       pos => {
//         const lat = pos.coords.latitude.toFixed(6);
//         const lng = pos.coords.longitude.toFixed(6);
//         setForm(p => ({ ...p, latitude: lat, longitude: lng }));
//         // Auto detect zone
//         if (isSaraiNoc) {
//           const zoneId = detectZoneFromCoords(parseFloat(lat), parseFloat(lng));
//           if (zoneId) {
//             setDetectedZone(zoneId);
//             setForm(p => ({ ...p, latitude: lat, longitude: lng, zone_id: String(zoneId) }));
//             toast.success(`Zone ${zoneId} detected from your location!`);
//           } else {
//             toast('Location detected but outside zone boundaries. Please select zone manually.', { icon: '⚠️' });
//           }
//         }
//       },
//       () => toast.error('Location access denied')
//     );
//   };

//   const addDocRow    = () => setDocRows(r => [...r, { name: '', file: null }]);
//   const removeDocRow = (i) => setDocRows(r => r.filter((_, idx) => idx !== i));
//   const updateDocRow = (i, key, val) => setDocRows(r => r.map((row, idx) => idx === i ? { ...row, [key]: val } : row));

//   const handleSubmit = async () => {
//     setSubmitting(true);
//     try {
//       const fd = new FormData();
//       fd.append('noc_type_id', selectedNoc.id);
//       Object.entries(form).forEach(([k, v]) => { if (v !== '') fd.append(k, v); });
//       docRows.forEach((row, i) => {
//         if (row.file) {
//           fd.append('files', row.file);
//           fd.append(`doc_name_${i}`, row.name || row.file.name);
//         }
//       });
//       const res = await api.post('/applications', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
//       toast.success(`Application ${res.application_no} submitted!`);
//       navigate('/user/applications');
//     } catch { toast.error('Submission failed. Please try again.'); }
//     finally { setSubmitting(false); }
//   };

//   const canProceed = () => {
//     if (step === 0) return !!selectedNoc;
//     if (step === 1) return true;
//     if (step === 2) {
//       const mobileOk = /^[6-9]\d{9}$/.test(form.applicant_mobile);
//       const emailOk  = !form.applicant_email || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.applicant_email);
//       const wardZoneOk = !isSaraiNoc || (form.ward_id && form.zone_id);
//       return !!form.applicant_name && mobileOk && emailOk && wardZoneOk;
//     }
//     if (step === 3) return docRows.some(r => r.file);
//     return true;
//   };

//   // Ward select handler — auto-fill zone from ward
//   const handleWardChange = (wardId) => {
//     const ward = wards.find(w => w.id === parseInt(wardId));
//     setForm(p => ({
//       ...p,
//       ward_id: wardId,
//       zone_id: ward ? String(ward.zone_id) : p.zone_id,
//     }));
//   };

//   return (
//     <div className="max-w-3xl mx-auto">
//       <div className="card mb-6">
//         <h1 className="text-2xl font-bold text-gray-800 mb-6">Apply for NOC</h1>

//         {/* Stepper */}
//         <div className="flex items-center mb-8 overflow-x-auto pb-2">
//           {steps.map((s, i) => (
//             <React.Fragment key={s}>
//               <div className={`flex items-center gap-2 flex-shrink-0 ${i <= step ? 'text-blue-700' : 'text-gray-400'}`}>
//                 <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold border-2
//                   ${i < step ? 'bg-blue-700 border-blue-700 text-white' : i === step ? 'border-blue-700 text-blue-700' : 'border-gray-300'}`}>
//                   {i < step ? '✓' : i + 1}
//                 </div>
//                 <span className="text-xs font-medium whitespace-nowrap">{s}</span>
//               </div>
//               {i < steps.length - 1 && <div className={`h-0.5 flex-1 mx-2 ${i < step ? 'bg-blue-700' : 'bg-gray-200'}`} />}
//             </React.Fragment>
//           ))}
//         </div>

//         {/* ── Step 0: Select NOC ── */}
//         {step === 0 && (
//           <div>
//             <h2 className="text-lg font-semibold mb-4">Select NOC Type</h2>
//             {nocTypes.length === 0
//               ? <LoadingSpinner />
//               : (
//                 <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
//                   {nocTypes.map(noc => (
//                     <label key={noc.id}
//                       className={`flex items-start gap-3 p-4 border-2 rounded-xl cursor-pointer transition-all
//                         ${selectedNoc?.id === noc.id ? 'border-blue-600 bg-blue-50' : 'border-gray-200 hover:border-blue-300'}`}>
//                       <input type="radio" name="noc_type" className="mt-1"
//                         checked={selectedNoc?.id === noc.id}
//                         onChange={() => handleSelectNoc(noc)} />
//                       <div>
//                         <p className="font-semibold text-gray-800">{noc.noc_name}</p>
//                         <p className="text-xs text-gray-500 mt-0.5">{noc.description || `Apply for ${noc.noc_name}`}</p>
//                         <span className="text-xs font-mono bg-gray-100 text-gray-600 px-2 py-0.5 rounded mt-1 inline-block">
//                           {noc.noc_code}
//                         </span>
//                       </div>
//                     </label>
//                   ))}
//                 </div>
//               )}
//           </div>
//         )}

//         {/* ── Step 1: Required Documents ── */}
//         {step === 1 && (
//           <div>
//             <h2 className="text-lg font-semibold mb-4">Required Documents for {selectedNoc?.noc_name}</h2>
//             {loadingDemands ? <LoadingSpinner /> : (
//               <>
//                 {demands.length > 0 && (
//                   <div className="p-4 bg-blue-50 border border-blue-200 rounded-xl mb-4">
//                     <p className="text-sm font-medium text-blue-800 mb-3">
//                       Please arrange the following documents before proceeding:
//                     </p>
//                     <ul className="space-y-2">
//                       {demands.map((d, i) => (
//                         <li key={d.id} className="flex items-center gap-2 text-sm text-blue-800">
//                           <span className={`w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold
//                             ${d.is_mandatory ? 'bg-red-500 text-white' : 'bg-gray-300 text-gray-600'}`}>
//                             {i + 1}
//                           </span>
//                           {d.document_name}
//                           {d.is_mandatory
//                             ? <span className="text-red-500 text-xs">*Required</span>
//                             : <span className="text-gray-400 text-xs">(Optional)</span>}
//                         </li>
//                       ))}
//                     </ul>
//                   </div>
//                 )}
//                 {selectedNoc?.template_file && selectedNoc.template_file.match(/\.pdf$/i) && (
//                   <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-xl">
//                     <div className="flex items-start gap-3">
//                       <span className="text-2xl flex-shrink-0">📄</span>
//                       <div className="flex-1">
//                         <p className="text-sm font-semibold text-yellow-800 mb-1">
//                           Template Form Required — {selectedNoc.noc_name}
//                         </p>
//                         <p className="text-xs text-yellow-700 mb-3">
//                           1️⃣ Download the template &nbsp; 2️⃣ Fill it completely &nbsp; 3️⃣ Upload in Step 4
//                         </p>
//                         <a href={`${API_BASE}${selectedNoc.template_file}`}
//                           download target="_blank" rel="noopener noreferrer"
//                           className="inline-flex items-center gap-2 bg-yellow-500 hover:bg-yellow-600 text-white font-semibold px-4 py-2 rounded-lg text-sm">
//                           📥 Download Template Form (PDF)
//                         </a>
//                       </div>
//                     </div>
//                   </div>
//                 )}
//               </>
//             )}
//           </div>
//         )}

//         {/* ── Step 2: Personal Details ── */}
//         {step === 2 && (
//           <div>
//             <h2 className="text-lg font-semibold mb-2">Applicant Details</h2>
//             {!isOperator && (
//               <p className="text-xs text-blue-600 bg-blue-50 border border-blue-200 rounded-lg px-3 py-2 mb-4">
//                 📋 Details auto-filled from your profile. You can edit before submitting.
//               </p>
//             )}

//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">

//               {/* Name */}
//               <div>
//                 <label className="form-label">Full Name <span className="text-red-500">*</span></label>
//                 <input type="text" className={`form-input ${errors.applicant_name ? 'border-red-400' : ''}`}
//                   value={form.applicant_name}
//                   onChange={e => { f('applicant_name', e.target.value); setErrors(p => ({...p, applicant_name:''})); }}
//                   placeholder="Enter full name" />
//                 {errors.applicant_name && <p className="text-xs text-red-500 mt-1">{errors.applicant_name}</p>}
//               </div>

//               {/* Mobile */}
//               <div>
//                 <label className="form-label">Mobile Number <span className="text-red-500">*</span></label>
//                 <div className="flex">
//                   <span className="inline-flex items-center px-3 border border-r-0 border-gray-300 rounded-l-lg bg-gray-50 text-gray-500 text-sm">+91</span>
//                   <input type="tel" maxLength={10}
//                     className={`form-input rounded-l-none flex-1 ${errors.applicant_mobile ? 'border-red-400' : ''}`}
//                     value={form.applicant_mobile}
//                     onChange={e => {
//                       const val = e.target.value.replace(/\D/g, '').slice(0, 10);
//                       f('applicant_mobile', val);
//                       setErrors(p => ({...p, applicant_mobile: val.length === 10 ? '' : '10 digit mobile required'}));
//                     }}
//                     placeholder="10 digit number" />
//                 </div>
//                 {form.applicant_mobile.length > 0 && form.applicant_mobile.length < 10 && (
//                   <p className="text-xs text-orange-500 mt-1">{form.applicant_mobile.length}/10 digits</p>
//                 )}
//                 {errors.applicant_mobile && <p className="text-xs text-red-500 mt-1">{errors.applicant_mobile}</p>}
//               </div>

//               {/* Email */}
//               <div>
//                 <label className="form-label">Email Address</label>
//                 <input type="email" className={`form-input ${errors.applicant_email ? 'border-red-400' : ''}`}
//                   value={form.applicant_email}
//                   onChange={e => {
//                     const val = e.target.value;
//                     f('applicant_email', val);
//                     const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
//                     setErrors(p => ({...p, applicant_email: val && !ok ? 'Invalid email' : ''}));
//                   }}
//                   placeholder="email@example.com" />
//                 {errors.applicant_email && <p className="text-xs text-red-500 mt-1">{errors.applicant_email}</p>}
//               </div>

//               {/* Address */}
//               <div className="sm:col-span-2">
//                 <label className="form-label">Address</label>
//                 <textarea className="form-input" rows={2} value={form.applicant_address}
//                   onChange={e => f('applicant_address', e.target.value)}
//                   placeholder="House no., Street, Area" />
//               </div>

//               {/* Location */}
//               <div>
//                 <label className="form-label">Latitude</label>
//                 <input type="text" className="form-input" value={form.latitude}
//                   onChange={e => f('latitude', e.target.value)} placeholder="e.g. 25.3407" />
//               </div>
//               <div>
//                 <label className="form-label">Longitude</label>
//                 <input type="text" className="form-input" value={form.longitude}
//                   onChange={e => f('longitude', e.target.value)} placeholder="e.g. 82.9794" />
//               </div>
//               <div className="sm:col-span-2">
//                 <button type="button" onClick={getLocation}
//                   className="btn-secondary text-sm flex items-center gap-2">
//                   📍 Get Current Location
//                   {isSaraiNoc && <span className="text-xs text-blue-600">(auto-detects zone)</span>}
//                 </button>
//               </div>

//               {/* ── Ward & Zone — only for Sarai NOC ── */}
//               {isSaraiNoc && (
//                 <>
//                   <div className="sm:col-span-2">
//                     <div className="p-3 bg-orange-50 border border-orange-200 rounded-xl text-xs text-orange-800">
//                       🏘️ <strong>Sarai NOC:</strong> Select your Ward. Zone will be auto-filled from ward or GPS.
//                       Your application will be routed to the respective Zone office.
//                     </div>
//                   </div>

//                   {/* Ward */}
//                   <div>
//                     <label className="form-label">Ward <span className="text-red-500">*</span></label>
//                     <select className={`form-select ${errors.ward_id ? 'border-red-400' : ''}`}
//                       value={form.ward_id}
//                       onChange={e => { handleWardChange(e.target.value); setErrors(p => ({...p, ward_id:''})); }}>
//                       <option value="">-- Select Ward --</option>
//                       {wards.map(w => (
//                         <option key={w.id} value={w.id}>
//                           Ward {w.ward_no} — {w.ward_name}
//                         </option>
//                       ))}
//                     </select>
//                     {errors.ward_id && <p className="text-xs text-red-500 mt-1">{errors.ward_id}</p>}
//                   </div>

//                   {/* Zone — auto from ward or GPS, but editable */}
//                   <div>
//                     <label className="form-label">
//                       Zone
//                       {detectedZone && <span className="ml-2 text-xs text-green-600">📍 GPS detected</span>}
//                     </label>
//                     <select className="form-select" value={form.zone_id}
//                       onChange={e => { f('zone_id', e.target.value); setDetectedZone(null); }}>
//                       <option value="">-- Select Zone --</option>
//                       {zones.map(z => (
//                         <option key={z.id} value={z.id}>
//                           {z.zone_name}
//                         </option>
//                       ))}
//                     </select>
//                     {form.zone_id && (
//                       <p className="text-xs text-green-600 mt-1">
//                         ✅ Will be routed to <strong>{zones.find(z => z.id === parseInt(form.zone_id))?.zone_name || `Zone ${form.zone_id}`} Office</strong>
//                       </p>
//                     )}
//                   </div>
//                 </>
//               )}

//               {/* Description */}
//               <div className="sm:col-span-2">
//                 <label className="form-label">Description / Purpose</label>
//                 <textarea className="form-input" rows={3} value={form.description}
//                   onChange={e => f('description', e.target.value)}
//                   placeholder="Describe the purpose of your NOC application" />
//               </div>
//             </div>
//           </div>
//         )}

//         {/* ── Step 3: Upload Documents ── */}
//         {step === 3 && (
//           <div>
//             <h2 className="text-lg font-semibold mb-4">Upload Documents</h2>

//             {selectedNoc?.template_file && selectedNoc.template_file.match(/\.pdf$/i) && (
//               <div className="flex items-center gap-3 p-3 bg-yellow-50 border border-yellow-300 rounded-xl mb-3">
//                 <span className="text-xl flex-shrink-0">⚠️</span>
//                 <div className="flex-1">
//                   <p className="text-xs font-semibold text-yellow-800">Template form upload required!</p>
//                   <p className="text-xs text-yellow-700">Make sure you upload the filled template form below.</p>
//                 </div>
//                 {selectedNoc.template_file?.match(/\.pdf$/i) && (
//                   <a href={`${API_BASE}${selectedNoc.template_file}`}
//                     download target="_blank" rel="noopener noreferrer"
//                     className="flex-shrink-0 text-xs bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-1.5 rounded-lg font-medium">
//                     📥 Download Again
//                   </a>
//                 )}
//               </div>
//             )}

//             <div className="space-y-3">
//               {docRows.map((row, i) => (
//                 <div key={i} className="flex gap-2 items-start">
//                   <div className="flex-1">
//                     <input className="form-input text-sm mb-1" placeholder="Document name"
//                       value={row.name} onChange={e => updateDocRow(i, 'name', e.target.value)} />
//                     <label className={`flex items-center gap-2 cursor-pointer border rounded-lg px-3 py-2 text-sm transition-all
//                       ${row.file ? 'border-green-400 bg-green-50 text-green-700' : 'border-gray-300 text-gray-500 hover:border-blue-300'}`}>
//                       {row.file
//                         ? <><span>✓</span><span className="truncate max-w-[200px]">{row.file.name}</span></>
//                         : <><span>📎</span><span>Choose file (PDF/Image/Word)</span></>}
//                       <input type="file" className="hidden"
//                         accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
//                         onChange={e => updateDocRow(i, 'file', e.target.files[0])} />
//                     </label>
//                     {row.mandatory && <p className="text-xs text-red-500 mt-0.5">* Required</p>}
//                   </div>
//                   {i > 0 && !row.mandatory && (
//                     <button onClick={() => removeDocRow(i)}
//                       className="text-red-400 hover:text-red-600 text-xl leading-none mt-1 flex-shrink-0">✕</button>
//                   )}
//                 </div>
//               ))}
//             </div>
//             <button onClick={addDocRow}
//               className="mt-3 text-sm text-blue-600 hover:text-blue-800 font-medium flex items-center gap-1">
//               ➕ Add More Document
//             </button>
//           </div>
//         )}

//         {/* ── Step 4: Submit ── */}
//         {step === 4 && (
//           <div>
//             <h2 className="text-lg font-semibold mb-4">Review & Submit</h2>
//             <div className="space-y-2 mb-6">
//               {[
//                 ['NOC Type',    selectedNoc?.noc_name],
//                 ['Name',        form.applicant_name],
//                 ['Mobile',      '+91 ' + form.applicant_mobile],
//                 ['Email',       form.applicant_email || '—'],
//                 ['Address',     form.applicant_address || '—'],
//                 ['Location',    form.latitude ? `${form.latitude}, ${form.longitude}` : '—'],
//                 ...(isSaraiNoc ? [
//                   ['Ward',  wards.find(w => w.id === parseInt(form.ward_id))?.ward_name || '—'],
//                   ['Zone',  zones.find(z => z.id === parseInt(form.zone_id))?.zone_name || '—'],
//                 ] : []),
//                 ['Documents',   docRows.filter(r => r.file).length + ' file(s) attached'],
//               ].map(([label, value]) => (
//                 <div key={label} className="flex gap-4 py-2 border-b border-gray-50 last:border-0">
//                   <span className="text-xs text-gray-400 w-28 flex-shrink-0">{label}</span>
//                   <span className="text-sm text-gray-800 font-medium">{value}</span>
//                 </div>
//               ))}
//             </div>
//             <div className="p-3 bg-blue-50 border border-blue-200 rounded-xl text-xs text-blue-700 mb-4">
//               ℹ️ Please review all details before submitting. Once submitted, you can edit only after an objection.
//             </div>
//             <button onClick={handleSubmit} disabled={submitting}
//               className="btn-success w-full py-3 text-base font-semibold">
//               {submitting ? '⏳ Submitting...' : '✅ Submit Application'}
//             </button>
//           </div>
//         )}
//       </div>

//       {/* Navigation */}
//       <div className="flex justify-between items-center">
//         <button
//           onClick={() => setStep(s => Math.max(0, s - 1))}
//           disabled={step === 0}
//           className="btn-secondary disabled:opacity-40">
//           ← Previous
//         </button>

//         {step < 4 && (
//           <button
//             onClick={() => setStep(s => s + 1)}
//             disabled={!canProceed()}
//             className="btn-primary disabled:opacity-40 disabled:cursor-not-allowed">
//             Next →
//           </button>
//         )}
//       </div>
//     </div>
//   );
// }
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import api from '../../services/api';
import toast from 'react-hot-toast';
import { LoadingSpinner } from '../../components/UI';
import zonesGeoJson from '../../data/zones.json';
import wardsData from '../../data/wards.json';

const API_BASE = (process.env.REACT_APP_API_URL || 'https://cmsapi3.vdavns.com/api').replace('/api', '');
const steps = ['Select NOC', 'Documents Required', 'Your Details', 'Upload Documents', 'Submit'];

// ── Point-in-polygon (ray casting) ───────────────────────────
function pointInPolygon(lat, lng, polygon) {
  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i][0], yi = polygon[i][1];
    const xj = polygon[j][0], yj = polygon[j][1];
    const intersect = ((yi > lat) !== (yj > lat)) &&
      (lng < (xj - xi) * (lat - yi) / (yj - yi) + xi);
    if (intersect) inside = !inside;
  }
  return inside;
}

// ── Detect zone from lat/lng ──────────────────────────────────
function detectZoneFromCoords(lat, lng) {
  for (const feature of zonesGeoJson.features) {
    const coords = feature.geometry.coordinates[0];
    // GeoJSON is [lng, lat] — swap for our check
    if (pointInPolygon(lng, lat, coords)) {
      return feature.properties.zone_id;
    }
  }
  return null;
}

export default function ApplyNOC() {
  const [step, setStep]             = useState(0);
  const [nocTypes, setNocTypes]     = useState([]);
  const [selectedNoc, setSelectedNoc] = useState(null);
  const [demands, setDemands]       = useState([]);
  const [loadingDemands, setLoadingDemands] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [errors, setErrors]         = useState({});
  const [detectedZone, setDetectedZone] = useState(null);

  const [form, setForm] = useState({
    applicant_name: '', applicant_address: '', applicant_email: '',
    applicant_mobile: '', latitude: '', longitude: '',
    description: '', ward_id: '', zone_id: '',
  });
  const [docRows, setDocRows] = useState([{ name: '', file: null }]);

  const navigate   = useNavigate();
  const { role }   = useSelector(s => s.auth);

  // Operator roles — no autofill
  const isOperator = ['operator1', 'operator2'].includes(role);

  // Sarai NOC — needs ward + zone
  const isSaraiNoc = selectedNoc?.noc_code?.toUpperCase().includes('SARAI') ||
                     selectedNoc?.noc_name?.toLowerCase().includes('sarai');

  const wards = wardsData.wards || [];
  const zones = wardsData.zones || [];

  useEffect(() => {
    api.get('/noc-types/public?active_only=1').then(r => setNocTypes(r.noc_types || []));

    // No autofill — user manually fills the form
  }, []);

  // Detect zone when lat/lng changes (for Sarai NOC)
  useEffect(() => {
    if (isSaraiNoc && form.latitude && form.longitude) {
      const zoneId = detectZoneFromCoords(
        parseFloat(form.latitude),
        parseFloat(form.longitude)
      );
      if (zoneId) {
        setDetectedZone(zoneId);
        setForm(p => ({ ...p, zone_id: String(zoneId) }));
      }
    }
  }, [form.latitude, form.longitude, isSaraiNoc]);

  const f = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const handleSelectNoc = async (noc) => {
    setSelectedNoc(noc);
    setLoadingDemands(true);
    try {
      const r = await api.get(`/noc-demands/${noc.id}`);
      setDemands(r.demands || []);
      if (r.demands?.length) {
        setDocRows(r.demands.map(d => ({ name: d.document_name, file: null, mandatory: d.is_mandatory })));
      } else {
        setDocRows([{ name: '', file: null }]);
      }
    } finally { setLoadingDemands(false); }
  };

  const getLocation = () => {
    navigator.geolocation.getCurrentPosition(
      pos => {
        const lat = pos.coords.latitude.toFixed(6);
        const lng = pos.coords.longitude.toFixed(6);
        setForm(p => ({ ...p, latitude: lat, longitude: lng }));
        // Auto detect zone
        if (isSaraiNoc) {
          const zoneId = detectZoneFromCoords(parseFloat(lat), parseFloat(lng));
          if (zoneId) {
            setDetectedZone(zoneId);
            setForm(p => ({ ...p, latitude: lat, longitude: lng, zone_id: String(zoneId) }));
            toast.success(`Zone ${zoneId} detected from your location!`);
          } else {
            toast('Location detected but outside zone boundaries. Please select zone manually.', { icon: '⚠️' });
          }
        }
      },
      () => toast.error('Location access denied')
    );
  };

  const addDocRow    = () => setDocRows(r => [...r, { name: '', file: null }]);
  const removeDocRow = (i) => setDocRows(r => r.filter((_, idx) => idx !== i));
  const updateDocRow = (i, key, val) => setDocRows(r => r.map((row, idx) => idx === i ? { ...row, [key]: val } : row));

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      const fd = new FormData();
      fd.append('noc_type_id', selectedNoc.id);
      Object.entries(form).forEach(([k, v]) => { if (v !== '') fd.append(k, v); });
      docRows.forEach((row, i) => {
        if (row.file) {
          fd.append('files', row.file);
          fd.append(`doc_name_${i}`, row.name || row.file.name);
        }
      });
      const res = await api.post('/applications', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      toast.success(`Application ${res.application_no} submitted!`);
      navigate('/user/applications');
    } catch { toast.error('Submission failed. Please try again.'); }
    finally { setSubmitting(false); }
  };

  const canProceed = () => {
    if (step === 0) return !!selectedNoc;
    if (step === 1) return true;
    if (step === 2) {
      const mobileOk = /^[6-9]\d{9}$/.test(form.applicant_mobile);
      const emailOk  = !form.applicant_email || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.applicant_email);
      const wardZoneOk = !isSaraiNoc || (form.ward_id && form.zone_id);
      return !!form.applicant_name && mobileOk && emailOk && wardZoneOk;
    }
    if (step === 3) return docRows.some(r => r.file);
    return true;
  };

  // Ward select handler — auto-fill zone from ward
  const handleWardChange = (wardId) => {
    const ward = wards.find(w => w.id === parseInt(wardId));
    setForm(p => ({
      ...p,
      ward_id: wardId,
      zone_id: ward ? String(ward.zone_id) : p.zone_id,
    }));
  };

  return (
    <div className="max-w-3xl mx-auto">
      <div className="card mb-6">
        <h1 className="text-2xl font-bold text-gray-800 mb-6">Apply for NOC</h1>

        {/* Stepper */}
        <div className="flex items-center mb-8 overflow-x-auto pb-2">
          {steps.map((s, i) => (
            <React.Fragment key={s}>
              <div className={`flex items-center gap-2 flex-shrink-0 ${i <= step ? 'text-blue-700' : 'text-gray-400'}`}>
                <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold border-2
                  ${i < step ? 'bg-blue-700 border-blue-700 text-white' : i === step ? 'border-blue-700 text-blue-700' : 'border-gray-300'}`}>
                  {i < step ? '✓' : i + 1}
                </div>
                <span className="text-xs font-medium whitespace-nowrap">{s}</span>
              </div>
              {i < steps.length - 1 && <div className={`h-0.5 flex-1 mx-2 ${i < step ? 'bg-blue-700' : 'bg-gray-200'}`} />}
            </React.Fragment>
          ))}
        </div>

        {/* ── Step 0: Select NOC ── */}
        {step === 0 && (
          <div>
            <h2 className="text-lg font-semibold mb-4">Select NOC Type</h2>
            {nocTypes.length === 0
              ? <LoadingSpinner />
              : (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {nocTypes.map(noc => (
                    <label key={noc.id}
                      className={`flex items-start gap-3 p-4 border-2 rounded-xl cursor-pointer transition-all
                        ${selectedNoc?.id === noc.id ? 'border-blue-600 bg-blue-50' : 'border-gray-200 hover:border-blue-300'}`}>
                      <input type="radio" name="noc_type" className="mt-1"
                        checked={selectedNoc?.id === noc.id}
                        onChange={() => handleSelectNoc(noc)} />
                      <div>
                        <p className="font-semibold text-gray-800">{noc.noc_name}</p>
                        <p className="text-xs text-gray-500 mt-0.5">{noc.description || `Apply for ${noc.noc_name}`}</p>
                        <span className="text-xs font-mono bg-gray-100 text-gray-600 px-2 py-0.5 rounded mt-1 inline-block">
                          {noc.noc_code}
                        </span>
                      </div>
                    </label>
                  ))}
                </div>
              )}
          </div>
        )}

        {/* ── Step 1: Required Documents ── */}
        {step === 1 && (
          <div>
            <h2 className="text-lg font-semibold mb-4">Required Documents for {selectedNoc?.noc_name}</h2>
            {loadingDemands ? <LoadingSpinner /> : (
              <>
                {demands.length > 0 && (
                  <div className="p-4 bg-blue-50 border border-blue-200 rounded-xl mb-4">
                    <p className="text-sm font-medium text-blue-800 mb-3">
                      Please arrange the following documents before proceeding:
                    </p>
                    <ul className="space-y-2">
                      {demands.map((d, i) => (
                        <li key={d.id} className="flex items-center gap-2 text-sm text-blue-800">
                          <span className={`w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold
                            ${d.is_mandatory ? 'bg-red-500 text-white' : 'bg-gray-300 text-gray-600'}`}>
                            {i + 1}
                          </span>
                          {d.document_name}
                          {d.is_mandatory
                            ? <span className="text-red-500 text-xs">*Required</span>
                            : <span className="text-gray-400 text-xs">(Optional)</span>}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                {selectedNoc?.template_file && selectedNoc.template_file.match(/\.pdf$/i) && (
                  <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-xl">
                    <div className="flex items-start gap-3">
                      <span className="text-2xl flex-shrink-0">📄</span>
                      <div className="flex-1">
                        <p className="text-sm font-semibold text-yellow-800 mb-1">
                          Template Form Required — {selectedNoc.noc_name}
                        </p>
                        <p className="text-xs text-yellow-700 mb-3">
                          1️⃣ Download the template &nbsp; 2️⃣ Fill it completely &nbsp; 3️⃣ Upload in Step 4
                        </p>
                        <a href={`${API_BASE}${selectedNoc.template_file}`}
                          download target="_blank" rel="noopener noreferrer"
                          className="inline-flex items-center gap-2 bg-yellow-500 hover:bg-yellow-600 text-white font-semibold px-4 py-2 rounded-lg text-sm">
                          📥 Download Template Form (PDF)
                        </a>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        )}

        {/* ── Step 2: Personal Details ── */}
        {step === 2 && (
          <div>
            <h2 className="text-lg font-semibold mb-2">Applicant Details</h2>


            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">

              {/* Name */}
              <div>
                <label className="form-label">Full Name <span className="text-red-500">*</span></label>
                <input type="text" className={`form-input ${errors.applicant_name ? 'border-red-400' : ''}`}
                  value={form.applicant_name}
                  onChange={e => { f('applicant_name', e.target.value); setErrors(p => ({...p, applicant_name:''})); }}
                  placeholder="Enter full name" />
                {errors.applicant_name && <p className="text-xs text-red-500 mt-1">{errors.applicant_name}</p>}
              </div>

              {/* Mobile */}
              <div>
                <label className="form-label">Mobile Number <span className="text-red-500">*</span></label>
                <div className="flex">
                  <span className="inline-flex items-center px-3 border border-r-0 border-gray-300 rounded-l-lg bg-gray-50 text-gray-500 text-sm">+91</span>
                  <input type="tel" maxLength={10}
                    className={`form-input rounded-l-none flex-1 ${errors.applicant_mobile ? 'border-red-400' : ''}`}
                    value={form.applicant_mobile}
                    onChange={e => {
                      const val = e.target.value.replace(/\D/g, '').slice(0, 10);
                      f('applicant_mobile', val);
                      setErrors(p => ({...p, applicant_mobile: val.length === 10 ? '' : '10 digit mobile required'}));
                    }}
                    placeholder="10 digit number" />
                </div>
                {form.applicant_mobile.length > 0 && form.applicant_mobile.length < 10 && (
                  <p className="text-xs text-orange-500 mt-1">{form.applicant_mobile.length}/10 digits</p>
                )}
                {errors.applicant_mobile && <p className="text-xs text-red-500 mt-1">{errors.applicant_mobile}</p>}
              </div>

              {/* Email */}
              <div>
                <label className="form-label">Email Address</label>
                <input type="email" className={`form-input ${errors.applicant_email ? 'border-red-400' : ''}`}
                  value={form.applicant_email}
                  onChange={e => {
                    const val = e.target.value;
                    f('applicant_email', val);
                    const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
                    setErrors(p => ({...p, applicant_email: val && !ok ? 'Invalid email' : ''}));
                  }}
                  placeholder="email@example.com" />
                {errors.applicant_email && <p className="text-xs text-red-500 mt-1">{errors.applicant_email}</p>}
              </div>

              {/* Address */}
              <div className="sm:col-span-2">
                <label className="form-label">Address</label>
                <textarea className="form-input" rows={2} value={form.applicant_address}
                  onChange={e => f('applicant_address', e.target.value)}
                  placeholder="House no., Street, Area" />
              </div>

              {/* Location */}
              <div>
                <label className="form-label">Latitude</label>
                <input type="text" className="form-input" value={form.latitude}
                  onChange={e => f('latitude', e.target.value)} placeholder="e.g. 25.3407" />
              </div>
              <div>
                <label className="form-label">Longitude</label>
                <input type="text" className="form-input" value={form.longitude}
                  onChange={e => f('longitude', e.target.value)} placeholder="e.g. 82.9794" />
              </div>
              <div className="sm:col-span-2">
                <button type="button" onClick={getLocation}
                  className="btn-secondary text-sm flex items-center gap-2">
                  📍 Get Current Location
                  {isSaraiNoc && <span className="text-xs text-blue-600">(auto-detects zone)</span>}
                </button>
              </div>

              {/* ── Ward & Zone — only for Sarai NOC ── */}
              {isSaraiNoc && (
                <>
                  <div className="sm:col-span-2">
                    <div className="p-3 bg-orange-50 border border-orange-200 rounded-xl text-xs text-orange-800">
                      🏘️ <strong>Sarai NOC:</strong> Select your Ward. Zone will be auto-filled from ward or GPS.
                      Your application will be routed to the respective Zone office.
                    </div>
                  </div>

                  {/* Ward */}
                  <div>
                    <label className="form-label">Ward <span className="text-red-500">*</span></label>
                    <select className={`form-select ${errors.ward_id ? 'border-red-400' : ''}`}
                      value={form.ward_id}
                      onChange={e => { handleWardChange(e.target.value); setErrors(p => ({...p, ward_id:''})); }}>
                      <option value="">-- Select Ward --</option>
                      {wards.map(w => (
                        <option key={w.id} value={w.id}>
                          Ward {w.ward_no} — {w.ward_name}
                        </option>
                      ))}
                    </select>
                    {errors.ward_id && <p className="text-xs text-red-500 mt-1">{errors.ward_id}</p>}
                  </div>

                  {/* Zone — auto from ward or GPS, but editable */}
                  <div>
                    <label className="form-label">
                      Zone
                      {detectedZone && <span className="ml-2 text-xs text-green-600">📍 GPS detected</span>}
                    </label>
                    <select className="form-select" value={form.zone_id}
                      onChange={e => { f('zone_id', e.target.value); setDetectedZone(null); }}>
                      <option value="">-- Select Zone --</option>
                      {zones.map(z => (
                        <option key={z.id} value={z.id}>
                          {z.zone_name}
                        </option>
                      ))}
                    </select>
                    {form.zone_id && (
                      <p className="text-xs text-green-600 mt-1">
                        ✅ Will be routed to <strong>{zones.find(z => z.id === parseInt(form.zone_id))?.zone_name || `Zone ${form.zone_id}`} Office</strong>
                      </p>
                    )}
                  </div>
                </>
              )}

              {/* Description */}
              <div className="sm:col-span-2">
                <label className="form-label">Description / Purpose</label>
                <textarea className="form-input" rows={3} value={form.description}
                  onChange={e => f('description', e.target.value)}
                  placeholder="Describe the purpose of your NOC application" />
              </div>
            </div>
          </div>
        )}

        {/* ── Step 3: Upload Documents ── */}
        {step === 3 && (
          <div>
            <h2 className="text-lg font-semibold mb-4">Upload Documents</h2>

            {selectedNoc?.template_file && selectedNoc.template_file.match(/\.pdf$/i) && (
              <div className="flex items-center gap-3 p-3 bg-yellow-50 border border-yellow-300 rounded-xl mb-3">
                <span className="text-xl flex-shrink-0">⚠️</span>
                <div className="flex-1">
                  <p className="text-xs font-semibold text-yellow-800">Template form upload required!</p>
                  <p className="text-xs text-yellow-700">Make sure you upload the filled template form below.</p>
                </div>
                {selectedNoc.template_file?.match(/\.pdf$/i) && (
                  <a href={`${API_BASE}${selectedNoc.template_file}`}
                    download target="_blank" rel="noopener noreferrer"
                    className="flex-shrink-0 text-xs bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-1.5 rounded-lg font-medium">
                    📥 Download Again
                  </a>
                )}
              </div>
            )}

            <div className="space-y-3">
              {docRows.map((row, i) => (
                <div key={i} className="flex gap-2 items-start">
                  <div className="flex-1">
                    <input className="form-input text-sm mb-1" placeholder="Document name"
                      value={row.name} onChange={e => updateDocRow(i, 'name', e.target.value)} />
                    <label className={`flex items-center gap-2 cursor-pointer border rounded-lg px-3 py-2 text-sm transition-all
                      ${row.file ? 'border-green-400 bg-green-50 text-green-700' : 'border-gray-300 text-gray-500 hover:border-blue-300'}`}>
                      {row.file
                        ? <><span>✓</span><span className="truncate max-w-[200px]">{row.file.name}</span></>
                        : <><span>📎</span><span>Choose file (PDF/Image/Word)</span></>}
                      <input type="file" className="hidden"
                        accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                        onChange={e => updateDocRow(i, 'file', e.target.files[0])} />
                    </label>
                    {row.mandatory && <p className="text-xs text-red-500 mt-0.5">* Required</p>}
                  </div>
                  {i > 0 && !row.mandatory && (
                    <button onClick={() => removeDocRow(i)}
                      className="text-red-400 hover:text-red-600 text-xl leading-none mt-1 flex-shrink-0">✕</button>
                  )}
                </div>
              ))}
            </div>
            <button onClick={addDocRow}
              className="mt-3 text-sm text-blue-600 hover:text-blue-800 font-medium flex items-center gap-1">
              ➕ Add More Document
            </button>
          </div>
        )}

        {/* ── Step 4: Submit ── */}
        {step === 4 && (
          <div>
            <h2 className="text-lg font-semibold mb-4">Review & Submit</h2>
            <div className="space-y-2 mb-6">
              {[
                ['NOC Type',    selectedNoc?.noc_name],
                ['Name',        form.applicant_name],
                ['Mobile',      '+91 ' + form.applicant_mobile],
                ['Email',       form.applicant_email || '—'],
                ['Address',     form.applicant_address || '—'],
                ['Location',    form.latitude ? `${form.latitude}, ${form.longitude}` : '—'],
                ...(isSaraiNoc ? [
                  ['Ward',  wards.find(w => w.id === parseInt(form.ward_id))?.ward_name || '—'],
                  ['Zone',  zones.find(z => z.id === parseInt(form.zone_id))?.zone_name || '—'],
                ] : []),
                ['Documents',   docRows.filter(r => r.file).length + ' file(s) attached'],
              ].map(([label, value]) => (
                <div key={label} className="flex gap-4 py-2 border-b border-gray-50 last:border-0">
                  <span className="text-xs text-gray-400 w-28 flex-shrink-0">{label}</span>
                  <span className="text-sm text-gray-800 font-medium">{value}</span>
                </div>
              ))}
            </div>
            <div className="p-3 bg-blue-50 border border-blue-200 rounded-xl text-xs text-blue-700 mb-4">
              ℹ️ Please review all details before submitting. Once submitted, you can edit only after an objection.
            </div>
            <button onClick={handleSubmit} disabled={submitting}
              className="btn-success w-full py-3 text-base font-semibold">
              {submitting ? '⏳ Submitting...' : '✅ Submit Application'}
            </button>
          </div>
        )}
      </div>

      {/* Navigation */}
      <div className="flex justify-between items-center">
        <button
          onClick={() => setStep(s => Math.max(0, s - 1))}
          disabled={step === 0}
          className="btn-secondary disabled:opacity-40">
          ← Previous
        </button>

        {step < 4 && (
          <button
            onClick={() => setStep(s => s + 1)}
            disabled={!canProceed()}
            className="btn-primary disabled:opacity-40 disabled:cursor-not-allowed">
            Next →
          </button>
        )}
      </div>
    </div>
  );
}